import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'

class Group {
    list(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.teamGroup}?${params}`)
    }

    update(data) {
        return BaseService.post(`${APIPath.teamGroupUpdate}`, data)
    }

    remove(id) {
        return BaseService.post(`${APIPath.teamGroup}/Remove?GroupId=${id}`)
    }

    add(data) {
        return BaseService.post(`${APIPath.teamGroup}`, data)
    }

    addGroupMembers(data) {
        return BaseService.post(`${APIPath.teamGroupMember}`, data)
    }

    updateGroupMembers(data) {
        return BaseService.post(`${APIPath.teamGroupMemberUpdate}`, data)
    }

    // New APIs

    insertTeamGroupCapa(data) {
        return BaseService.post(`${APIPath.teamGroupCapa}`, data)
    }

    updateTeamGroupCapa(data, TemplateId) {
        return BaseService.post(
            `${APIPath.teamGroupCapaUpdate}?TemplateId=${TemplateId}`,
            data,
        )
    }

    getTeamGroupCapa(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.teamGroupCapa}?${params}`)
    }

    // Inside GroupService
    getTeamGroupCapaByTemplateId(TemplateId) {
        return BaseService.get(
            `${APIPath.teamGroupCapa}?TemplateId=${TemplateId}`,
        )
    }

    getTeamGroupCapaByMappingId(mappingId) {
        return BaseService.get(
            `${APIPath.teamGroupCapa}?mappingId=${mappingId}`,
        )
    }

    removeTeamGroupCapaByMappingId(mappingId) {
        return BaseService.post(
            `${APIPath.teamGroupCapaRemove}?mappingId=${mappingId}`,
        )
    }

    createTeamGroup(data) {
        return BaseService.post(`${APIPath.teamGroup}`, data)
    }

    updateTeamGroup(data) {
        return BaseService.put(`${APIPath.teamGroupUpdate}`, data)
    }

    getGroupTemplates(groupId) {
        return BaseService.get(`${APIPath.teamGroupTemplates}${groupId}`)
    }

    getRoleTypes() {
        return BaseService.get(`${APIPath.roleType}`)
    }

    // Roles for the invite / add / edit USER screens. Companies on the department role model get Admin, Auditor,
    // Department user, Viewer and Template manager; every other company gets the same list as getRoleTypes().
    getUserRoleTypes() {
        return BaseService.get(`${APIPath.roleType}?purpose=user`)
    }

    getPermissions() {
        return BaseService.get(`${APIPath.permissions}`)
    }
}

const GroupService = new Group()
Object.freeze(GroupService)
export { GroupService }
